{
  "title": "КОЛЕСО УДАЧИ",
  "description": "Испытай удачу каждый день!",
  "available": "Сегодняшний бесплатный шанс готов!",
  "spin": "🎡 КРУТИТЬ",
  "spinning": "Колесо крутится...",
  "winTitle": "Поздравляем!",
  "win": "Вы выиграли {{amount}} AZN бонуса!",
  "used": "🎁 Сегодняшний шанс уже использован! Приходи завтра!",
  "homeCta": "Нажмите на колесо и испытайте удачу",
  "homeUsed": "Приходите завтра!",
  "ribbonReady": "ИСПЫТАЙ УДАЧУ",
  "ribbonUsed": "ПРИХОДИ ЗАВТРА",
  "hubSpin": "КРУТИТЬ",
  "sheetHint": "Нажмите на колесо и испытайте удачу",
  "winAmount": "ВЫ ВЫИГРАЛИ {{amount}} AZN!",
  "closeResult": "Закрыть",
  "demoBadge": "Визуальная демонстрация — реальный бонус ещё не активен",
  "loginRequiredBadge": "Войдите, чтобы получить реальный бонус",
  "loginRequired": "Войдите, чтобы крутить реальное колесо.",
  "demoWinNote": "Это только визуальный результат. Бонусный баланс не пополнен.",
  "testBadge": "ТЕСТ САЙТА — TEST BONUS, без вывода",
  "testWinNote": "{{amount}} AZN TEST BONUS зачислено. Эти средства нельзя вывести и они не добавляются к реальному балансу.",
  "testBalance": "Тестовый бонус",
  "testLedger": "TEST BONUS (без вывода)",
  "testNotWithdrawable": "Тестовые средства нельзя вывести",
  "testExpires": "Срок тестового бонуса: {{when}}",
  "testPrize": "Тестовый приз: {{amount}} AZN",
  "mute": "Выключить звук",
  "unmute": "Включить звук",
  "close": "Закрыть",
  "openAria": "Открыть колесо удачи VBB",
  "spinFailed": "Вращение не удалось. Попробуйте ещё раз чуть позже.",
  "wageringTitle": "Отыгрыш бонуса",
  "bonusBalance": "Бонусный баланс",
  "wageringMultiplier": "Требование",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Требование по отыгрышу",
  "wageringCompleted": "Выполнено",
  "wageringRemaining": "Осталось",
  "bonusStatus": "Статус бонуса",
  "withdrawalEligibility": "Вывод",
  "bonusNotWithdrawable": "Бонус нельзя вывести, пока конвертация не одобрена"
}
